import FilterOption from '@/domain/FilterOption'
import { defaultPressPageOffset, defaultPressPageSize } from '@/infrastructure/Configuration'

export default {
  labelsLoaded (state, labelsLoaded) {
    state.labelsLoaded = labelsLoaded
  },
  loading (state) {
    state.loading += 1
  },
  free (state) {
    state.loading -= 1
  },
  setPressReleases (state, pressReleases) {
    state.pressReleases = pressReleases
  },
  setAreas (state, areas) {
    state.areas = areas
  },
  setTopics (state, topics) {
    state.topics = topics
  },
  setYears (state, years) {
    state.years = years
  },
  setAreaDropdownOptions (state, areas) {
    state.areaDropdownOptions = state.filters.areas.map((area) => {
      if (!areas[area]) {
        return
      }
      return {
        key: area,
        name: areas[area].name,
        isDisabled: false
      }
    }).filter(Boolean)
  },
  setTopicDropdownOptions (state, topics) {
    state.topicDropdownOptions = state.filters.topics.map((topic) => {
      if (!topics[topic]) {
        return
      }
      return {
        key: topic,
        name: topics[topic].name,
        isDisabled: false
      }
    }).filter(Boolean)
  },
  setYearDropdownOptions (state, years) {
    state.yearDropdownOptions = years.map((year) => {
      return {
        key: year,
        name: String(year),
        isDisabled: false
      }
    })
  },
  updateFiltersDropdownOptions (state, { newFilters, type, selectedFilters }) {
    state.areaDropdownOptions = state.filters.areas.map((area) => {
      if (!state.areas[area]) {
        return
      }

      return {
        key: area,
        name: state.areas[area].name,
        isDisabled: (() => {
          if (selectedFilters < 2) {
            const isSelf = type === 'Area'
            const isDeselectingSelf = state.selectedArea.key === 'allAreas'
            const isDeselectingOthers = state.selectedTopic.key === 'allTopics' && state.selectedYear.key === 'allYears'

            if ((isSelf && !isDeselectingSelf) || (!isSelf && isDeselectingOthers)) {
              return false
            }
          }

          return !newFilters.areas.includes(area)
        })()
      }
    }).filter(Boolean)

    state.topicDropdownOptions = state.filters.topics.map((topic) => {
      if (!state.topics[topic]) {
        return
      }

      return {
        key: topic,
        name: state.topics[topic].name,
        isDisabled: (() => {
          if (selectedFilters < 2) {
            const isSelf = type === 'topic'
            const isDeselectingSelf = state.selectedTopic.key === 'allTopics'
            const isDeselectingOthers = state.selectedArea.key === 'allAreas' && state.selectedYear.key === 'allYears'

            if ((isSelf && !isDeselectingSelf) || (!isSelf && isDeselectingOthers)) {
              return false
            }
          }

          return !newFilters.topics.includes(topic)
        })()
      }
    }).filter(Boolean)

    state.yearDropdownOptions = state.filters.years.map((year) => {
      return {
        key: year,
        name: String(year),
        isDisabled: (() => {
          if (selectedFilters < 2) {
            const isSelf = type === 'year'
            const isDeselectingSelf = state.selectedYear.key === 'allYears'
            const isDeselectingOthers = state.selectedTopic.key === 'allTopics' && state.selectedArea.key === 'allAreas'

            if ((isSelf && !isDeselectingSelf) || (!isSelf && isDeselectingOthers)) {
              return false
            }
          }

          return !newFilters.years.includes(year)
        })()
      }
    })
  },
  setFilters (state, filters) {
    state.filters = filters
  },
  setPagination (state, pagination) {
    state.pagination = pagination
  },
  setPaginationTotal (state, total) {
    state.pagination.total = total
  },
  setPaginationTotalPages (state, totalPages) {
    state.pagination.totalPages = totalPages
  },
  setPaginationOffset (state, offset) {
    state.pagination.offset = offset
  },
  setPaginationLimit (state, limit) {
    state.pagination.limit = limit
  },
  setSelectedFilters (state, { type, option }) {
    state[`selected${type}`] = option
  },
  clearFilters (state) {
    state.selectedArea = FilterOption.fromJSON({
      name: '',
      key: 'allAreas',
      isDisabled: false
    })
    state.selectedTopic = FilterOption.fromJSON({
      name: '',
      key: 'allTopics',
      isDisabled: false
    })
    state.selectedYear = FilterOption.fromJSON({
      name: '',
      key: 'allYears',
      isDisabled: false
    })
    state.pagination.offset = defaultPressPageOffset
    state.pagination.limit = defaultPressPageSize
  },
  toggleMobileMenu (state) {
    state.isMobileMenuToggled = !state.isMobileMenuToggled
  },
  setQueryParamError (state, status) {
    state.queryParamError = status
  }
}
